import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.584 3.235C6.464 1.04 9.067 0 11.888 0c2.693 0 5.074.645 6.911 1.963 1.857 1.332 3.07 3.287 3.502 5.712a1.25 1.25 0 1 1-2.461.438c-.325-1.822-1.202-3.19-2.497-4.118-1.314-.942-3.146-1.495-5.455-1.495-2.18 0-4.056.786-5.406 2.361-1.365 1.594-2.302 4.128-2.302 7.81 0 3.552 1.201 5.696 2.74 6.977 1.58 1.316 3.676 1.852 5.64 1.852 3.878 0 6.255-2.282 6.366-4.778.055-1.239-.462-2.24-1.422-2.973l-.07-.053c-.193.878-.512 1.66-.952 2.328-.92 1.397-2.32 2.213-3.924 2.331-1.48.11-2.722-.246-3.63-.976a3.84 3.84 0 0 1-1.434-2.771c-.048-.823.09-2.038 1.028-3.043.943-1.01 2.463-1.561 4.635-1.561.641 0 1.268.047 1.872.143-.213-1.05-.693-1.56-1.109-1.836-.563-.375-1.21-.447-1.525-.447-.884 0-1.667.332-2.403 1.176a1.25 1.25 0 0 1-1.885-1.642c1.172-1.345 2.624-2.034 4.288-2.034.583 0 1.781.115 2.909.864 1.193.793 2.142 2.188 2.31 4.409l.018.289c.5.234.966.513 1.389.836 1.559 1.19 2.496 2.951 2.402 5.071C21.235 21.057 17.345 24 12.56 24c-2.367 0-5.088-.64-7.24-2.43-2.193-1.826-3.64-4.721-3.64-8.898 0-4.086 1.04-7.263 2.904-9.437m10.49 9.461a9.2 9.2 0 0 0-1.917-.192c-1.79 0-2.514.453-2.807.767-.297.318-.386.743-.36 1.19.02.354.182.709.507.97.32.259.899.503 1.877.431.82-.06 1.52-.455 2.02-1.213.312-.474.562-1.12.68-1.953",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSocialMediaThreads = { render };
export {
  brandSocialMediaThreads as default,
  render
};
//# sourceMappingURL=brand-social-media-threads.svg.js.map
